import { DEMO_PASSWORD, demoDiaryUpload } from './seed/customers'
import { db } from './db'
import type { DemoLogin } from '../core/types/backend'

/**
 * DEMO — wat de schermen van Mijn omgeving van de demo mogen weten.
 * Loopt via de api-laag (accountApi.demoLogins / demoSamplePhoto), zodat geen
 * scherm de demo-database zelf kent. Het testaccount van het beheer staat in
 * demo/adminBackend.ts, zodat het niet in de webshop-bundel komt.
 */
export const demoCustomerLogins = (): DemoLogin[] => db.logins().map((l) => ({ ...l, password: DEMO_PASSWORD }))

/**
 * Voorbeeldfoto voor het fotodagboek zonder camera, als bestand (zoals een echte upload).
 * Lukt ophalen niet (geen CORS of offline), dan een effen vlak in de huisstijl.
 */
export async function demoSamplePhoto(): Promise<Blob> {
  try {
    const res = await fetch(demoDiaryUpload, { mode: 'cors' })
    if (res.ok) return await res.blob()
  } catch {
    /* val terug op het vlak hieronder */
  }
  const canvas = document.createElement('canvas')
  canvas.width = 600
  canvas.height = 800
  const ctx = canvas.getContext('2d')
  if (ctx) {
    ctx.fillStyle = '#e8ddd0'
    ctx.fillRect(0, 0, canvas.width, canvas.height)
  }
  return new Promise((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Geen voorbeeldfoto'))), 'image/jpeg', 0.8))
}

/**
 * De bevestigingslink die de server anders mailt, voor het ingelogde account. Zelfde vorm als
 * demoAccountBackend.verifyEmail verwacht. `null` als niemand is ingelogd.
 */
export function demoVerifyLink(): string | null {
  const id = db.sessionId()
  const account = id ? db.account(id) : null
  if (!account) return null
  const url = new URL('/account', window.location.origin)
  url.searchParams.set('verifieer', `${account.customer.id}.${account.customer.email}`)
  return url.pathname + url.search
}
